<template>
  <scroll-bar>
    <div class="admin-brand" :class="{ 'is-collapse': isCollapse }">
      <div class="admin-brand-mark">M</div>
      <div class="admin-brand-copy">
        <div class="admin-brand-name">MilesLink</div>
        <div class="admin-brand-subtitle">运营后台</div>
      </div>
    </div>
    <el-menu
      class="admin-menu"
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="var(--admin-surface)"
      text-color="var(--admin-text-regular)"
      active-text-color="var(--admin-primary)"
    >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      // return this.$router.options.routes
      return this.routers
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.admin-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 64px;
  padding: 0 18px;
  border-bottom: 1px solid var(--admin-border);
  overflow: hidden;
}

.admin-brand-mark {
  display: flex;
  flex: 0 0 32px;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: var(--admin-surface);
  font-size: 16px;
  font-weight: 700;
  background: linear-gradient(135deg, var(--admin-primary-accent) 0%, var(--admin-primary) 100%);
}

.admin-brand-copy {
  min-width: 0;
}

.admin-brand-name {
  color: var(--admin-text-primary);
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
}

.admin-brand-subtitle {
  margin-top: 3px;
  color: var(--admin-text-muted);
  font-size: 12px;
  line-height: 1.2;
}

.admin-brand.is-collapse {
  justify-content: center;
  padding: 0;
  .admin-brand-copy {
    display: none;
  }
}

.admin-menu {
  padding: 10px 0 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue